export default {
      id: "inputNumberArrowDown-usage",
      viewBox: "0 0 14 14",
      url: "assets/" + "sprite.svg#inputNumberArrowDown-usage",
      toString: function () {
        return this.url;
      }
    }